import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";

interface RaDecErrorChartProps {
  imagesForView: ImageMetadata[];
}

const RaDecErrorChart: React.FC<RaDecErrorChartProps> = ({ imagesForView }) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      borderRadius: 3,
      p: 3,
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      minHeight: 400,
    }}
  >
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
    >
      RA vs DEC Error
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Comparison of RA and DEC guiding errors
    </Typography>
    {imagesForView.length === 0 ? (
      <Typography color="text.secondary">No data available.</Typography>
    ) : (
      <ResponsiveContainer width="100%" height={280}>
        <LineChart
          data={imagesForView.map((img, i) => ({
            frame: i + 1,
            ra: img.GuidingRMSRAArcSec,
            dec: img.GuidingRMSDECArcSec,
          }))}
        >
          <XAxis
            dataKey="frame"
            stroke="#a0a0a0"
            tick={{ fill: "#a0a0a0" }}
            tickLine={false}
            axisLine={{ stroke: "#333" }}
          />
          <YAxis
            stroke="#a0a0a0"
            tick={{ fill: "#a0a0a0" }}
            tickLine={false}
            axisLine={{ stroke: "#333" }}
            domain={[0, "auto"]}
          />
          <Tooltip
            contentStyle={{
              background: "#222",
              border: "1px solid #444",
              color: "#fff",
            }}
            labelStyle={{ color: "#fff" }}
          />
          <Line
            type="monotone"
            dataKey="ra"
            stroke="#4fc3f7"
            strokeWidth={2}
            dot={false}
            name="RA Error"
          />
          <Line
            type="monotone"
            dataKey="dec"
            stroke="#ff8a65"
            strokeWidth={2}
            dot={false}
            name="DEC Error"
          />
        </LineChart>
      </ResponsiveContainer>
    )}
  </Box>
);

export default RaDecErrorChart;
